module.exports = {
  theme: {
    fontFamily: {
      sans: ['Roboto'],
      mono: ['Roboto Mono'],
    },
    extend: {}
  },
  variants: {},
  plugins: []
}
